import { create } from 'zustand';
import { tokenStore } from '@/lib/api/client';
import type { TouristProfile } from '@/features/marketplace/types';

type AuthState = {
  user: TouristProfile | null;
  isLoggedIn: boolean;
  login: (user: TouristProfile, accessToken: string, refreshToken: string) => void;
  logout: () => void;
  setUser: (user: TouristProfile) => void;
};

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isLoggedIn: !!tokenStore.get(),

  login(user, accessToken, refreshToken) {
    tokenStore.set(accessToken, refreshToken);
    set({ user, isLoggedIn: true });
  },

  logout() {
    tokenStore.clear();
    set({ user: null, isLoggedIn: false });
  },

  setUser(user) {
    set({ user });
  },
}));
